import {
  quoteNumberSequenceQuery,
  tenantQuotingSettingsQuery,
} from "@common/api/quoting/settings"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { PageContent } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { GeneralForm } from "./general/-components/form/general-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/general",
)({
  staticData: {
    breadcrumb: [{ label: "Quoting - General" }],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      "quote_settings:read",
      "/settings/workspace/general",
    ),
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(tenantQuotingSettingsQuery()),
      queryClient.ensureQueryData(quoteNumberSequenceQuery()),
    ]),
  component: QuotingGeneralPage,
})

function QuotingGeneralPage(): React.ReactElement {
  const { data: settings } = useSuspenseQuery(tenantQuotingSettingsQuery())
  const { data: sequence } = useSuspenseQuery(quoteNumberSequenceQuery())
  const showToast = useCustomToast()

  return (
    <PageContent>
      <GeneralForm
        settings={settings}
        sequence={sequence}
        onSave={() =>
          showToast("Saved", "Quoting settings updated.", "success")
        }
      />
    </PageContent>
  )
}
